import { Grid, Text } from '@mantine/core';
import { ORBIT_DISABLED, ORBIT_GRAY } from '@/theme/colors';

interface PanelRowProps {
  label: string;
  value: string;
  /** Faint, for a value that says nothing is on file ("Not provided"), as `PanelSelectRow`'s placeholder. */
  muted?: boolean;
}

/**
 * The Intake and billing group's label-value row.
 *
 * Deliberately mirrors `shared/DetailRow` — same 3/9 grid, same 13px/16px
 * `ORBIT_GRAY` label and 14px/20px black value — rather than restyling
 * anything. It exists for the faint `muted` value ("Not set") that `DetailRow`
 * has no way to say. Colour lives only in the status badges, never in a row.
 *
 * Renders nothing on an empty value, which is how the panel's absent-not-blank
 * rule is enforced: a row with nothing to say would read as a data fault.
 */
export function PanelRow({ label, value, muted }: PanelRowProps) {
  if (!value) return null;

  return (
    <Grid align="flex-start" style={{ width: '100%' }}>
      <Grid.Col span={3}>
        <Text style={{ fontSize: 13, lineHeight: '16px', color: ORBIT_GRAY }}>{label}</Text>
      </Grid.Col>
      <Grid.Col span={9}>
        <Text
          style={{
            fontSize: 14,
            lineHeight: '20px',
            color: muted ? ORBIT_DISABLED : 'var(--mantine-color-black)',
          }}
        >
          {value}
        </Text>
      </Grid.Col>
    </Grid>
  );
}
